// extracted by mini-css-extract-plugin
export default {"formContainer":"ContractForm_formContainer__r3x-A","editIcon":"ContractForm_editIcon__90KIS"};